import type { FaireProductEntity } from "../../entity_types/product";

export const p_3jmj9b7gwz: FaireProductEntity = {
  token: "p_3jmj9b7gwz",
  type: "product",
  name: "Cordyceps - Fruiting Body - 1:1 Water Extracted - Organic",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/d48353ba5ff11810b76e1d6c71d6f505fdb69f0f9935560e83a29aab6dd486e5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f2c6b8db40657ba630b9aac00195de6614d3944825779786dfb260bd193a32f1.png",
    "https://cdn.faire.com/fastly/dd23ddb3db0a5bfe026af00639e70b5f04a5d968718d27603fc7ac0f656525ee.jpeg",
  ],
  priceDollars: 16.2,
  description:
    "\nCordyceps are known to support energy levels, physical performance, and respiratory health.* \n\nOur Cordyceps are organically cultivated in their favorite substrates (no starch, grains, or fillers) and 1:1 water extracted for bioavailability. \n\nFun Fact: Cordyceps has 600 subspecies and has been used across Asia for thousands of years as a remedy for fatigue and to support the kidneys which store our Qi, or life force energy, in Chinese Medicine. \n\nBETA GLUCANS | 160mg per serving\n\nSERVINGS | 2 grams, 31 servings per package\n\n✓ Always grown outdoors in hoop houses, not in labs.\n\n✓ Triple tested for safety & Mushroom compounds\n\n\n*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease or health condition. ",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:46.553Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
